/**
 * Asks for confirmation to leave/reload if there are unsaved changes.
 */
import { useEffect } from 'react';

// import Router from 'next/router';

// TODO: FIX THIS

type OptionsType = {
    disableBeforeUnloadListener?: boolean;
};

export default (_confirmationMessage: string, _options?: OptionsType) => {
    // useEffect(() => {
    //     if (window) {
    //         Router.beforePopState(() => {
    //             const result = window.confirm(confirmationMessage);
    //             if (!result) {
    //                 const currentPath = Router.asPath;
    //                 window.history.replaceState(
    //                     {
    //                         ...window.history.state,
    //                         as: currentPath,
    //                         url: currentPath,
    //                     },
    //                     '',
    //                     currentPath,
    //                 );
    //             }
    //             return result;
    //         });
    //         if (!options?.disableBeforeUnloadListener) {
    //             window.onbeforeunload = () => {
    //                 return true;
    //             };
    //         }
    //     }
    //     return () => {
    //         if (window && !options?.disableBeforeUnloadListener) {
    //             window.onbeforeunload = null;
    //         }
    //         Router.beforePopState(() => {
    //             return true;
    //         });
    //     };
    //     // we no trigger re render when the options change during runtime
    // }, [options]);
};
